
import { defineComponent } from 'vue';

import FormField from '@/components/forms/FormField.vue';

export default defineComponent({
  name: 'active-select',
  components: {
    FormField,
  },
  emits: ['change', 'close'],
  props: {
    containerClass: {
      default: 'col-lg-4',
      type: String,
    },
    name: {
      default: 'active',
      type: String,
    },
    label: {
      default: 'Active',
      type: String,
    },
    value: {
      default: '',
      type: String,
    },
  },
  data: () => ({
    options: [
      {
        label: 'Yes',
        value: 'yes',
      },
      {
        label: 'No',
        value: 'no',
      },
    ],
  }),
  methods: {
    handleChange(value) {
      this.$emit('change', value);
    },
    handleClose() {
      this.$emit('close');
    },
  },
});
